import React from 'react';
import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react';

interface AlertModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
  type?: 'error' | 'info' | 'success';
}

export const AlertModal: React.FC<AlertModalProps> = ({ isOpen, message, onClose, type = 'error' }) => {
  if (!isOpen) return null;

  const config = {
    error: {
      title: 'Atenção / Erro',
      icon: <AlertCircle className="w-6 h-6 text-red-600 dark:text-red-400 shrink-0" />,
      bgHeader: 'bg-red-50/80 dark:bg-red-950/40 border-red-200/60 dark:border-red-900/40 text-red-700 dark:text-red-300',
      btnBg: 'bg-red-600 hover:bg-red-700 text-white shadow-red-600/20'
    },
    success: {
      title: 'Sucesso',
      icon: <CheckCircle2 className="w-6 h-6 text-emerald-600 dark:text-emerald-400 shrink-0" />,
      bgHeader: 'bg-emerald-50/80 dark:bg-emerald-950/40 border-emerald-200/60 dark:border-emerald-900/40 text-emerald-700 dark:text-emerald-300',
      btnBg: 'bg-emerald-600 hover:bg-emerald-700 text-white shadow-emerald-600/20'
    },
    info: {
      title: 'Informação',
      icon: <Info className="w-6 h-6 text-brand-600 dark:text-brand-400 shrink-0" />,
      bgHeader: 'bg-brand-50/80 dark:bg-brand-950/40 border-brand-200/60 dark:border-brand-900/40 text-brand-700 dark:text-brand-300',
      btnBg: 'bg-brand-600 hover:bg-brand-700 text-white shadow-brand-600/20'
    }
  }[type];

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-slate-200/80 dark:border-slate-800 animate-scale-in">
        <div className={`p-4 sm:p-5 flex items-center gap-3 border-b ${config.bgHeader}`}>
          {config.icon}
          <h3 className="font-bold text-base flex-1 tracking-tight">
            {config.title}
          </h3>
          <button 
            onClick={onClose} 
            className="p-1.5 hover:bg-black/10 dark:hover:bg-white/10 rounded-lg transition-colors text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
            aria-label="Fechar modal"
          >
            <X size={18} />
          </button>
        </div>
        <div className="p-6 text-slate-600 dark:text-slate-300 text-sm leading-relaxed whitespace-pre-line font-medium">
          {message}
        </div>
        <div className="p-4 bg-slate-50/50 dark:bg-slate-900/50 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-2">
          <button
            onClick={onClose}
            className={`px-5 py-2.5 rounded-xl font-bold text-sm shadow-md transition-all active:scale-95 ${config.btnBg}`}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

